import { Box, Stack } from '@mui/material';
import { CleaningMission } from '@silbo/core';
import { colors } from '@silbo/ui';
import { useTranslation } from 'react-i18next';
import { formatElapsed, lastStartedAt } from '../utils/elapsed';

type MissionStatusBannerProps = {
  mission: CleaningMission;
  userId?: string;
  now: Date;
};

const MissionStatusBanner = ({ mission, userId, now }: MissionStatusBannerProps) => {
  const { t } = useTranslation('environmental-cleaning');
  if (mission.status !== 'in-progress') {
    return null;
  }
  const startedAt = lastStartedAt(mission);
  const isMine = !!userId && mission.cleaner?.id === userId;
  const status = isMine
    ? t('missions.current.label')
    : t('missions.row.inProgressBy', { name: mission.cleanerName ?? '' });

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      sx={{
        paddingY: 3,
        paddingX: '14px',
        border: `3px solid ${colors.green[40]}`,
        borderRadius: '14px',
        fontSize: 13,
        fontWeight: 700,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: colors.green[80],
      }}
    >
      <Box sx={{ flex: 'none', width: 8, height: 8, borderRadius: '4px', bgcolor: colors.green[60] }} />
      {startedAt ? t('mission.statusSince', { status, duration: formatElapsed(startedAt, now) }) : status}
    </Stack>
  );
};

export default MissionStatusBanner;
